export default "__VITE_ASSET__CGASd2lN__"